import React, {useCallback, useEffect, useState} from 'react'
import ProgKeyLabel from './ProgKeyLabel';
import ProgKeyEdit from './ProgKeyEdit';
import Leds from '../leds/Leds';
import Glide from '../glide/Glide';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import '../glide/Glide.css'
import '../ConfigTable.css'
import './ProgKeyCtrl.css';

export default function ProgKeyCtrl({folderPath, keyName, kInfo, tabIx = '1', ...rest}) {  
  const LABEL_MODE = 'labelMode';
  const TEXT_INPUT_MODE = 'textInputMode'
  const [mode, setMode]               = useState(kInfo?.keyEdit ? TEXT_INPUT_MODE : LABEL_MODE);
  const [locked, setLocked]           = useState(kInfo.keyLocked);
  const [justCreated, setJustCreated] = useState(kInfo.justCreated);
  const {tagKeyLocked, resetKeyLocked}= useItemListenerContext();

  // TODO: Kaze --> where the private queue name is based on the endpoint name.  so private-config-key-lock and team-config-key-lock
  //  const {sendRequest:lockKey} = useWebSocketIO('config-lock-key', onPrivateConfigKeyLock, onTeamConfigKeyLock);

  const setEditMode = useCallback(() => {
    if (!locked) {
      setMode(TEXT_INPUT_MODE);
    }
    else {
      // indication of a locked click...
      // console.log('Key LOCKED');
    }
  }, [locked]);

  const setLabelMode = () => {
    setMode(LABEL_MODE);
  }

  useEffect(()=>{
    setMode(kInfo?.keyEdit ? TEXT_INPUT_MODE : LABEL_MODE);
    setLocked(kInfo.keyLocked);
    setJustCreated(kInfo.justCreated);
    //  Similarly:
    //  - setModified
    //  - setSavingInProgress
    //  - isHIDDEN! Very useful with ACL but acl means server side will not allow to even get the elements so...
    //  - isReadOnly - based on ACL.
  }, [kInfo]);

  // TODO: save keyLocked in DB, Listen to event onLocked at ConfigTable level, update configsData accordingly to render the locked key.
  const lockMe = (e) => {
    e.preventDefault();        
    tagKeyLocked(folderPath, keyName)
      .then(()=>setLocked(true));        
  }

  const unlockMe = () => {    
    resetKeyLocked(folderPath, keyName)
      .then(()=> setLocked(false));
  }

  // ---[  Render  ]---

  return (
    <div className={`progKeyCtrl withGliders`} onContextMenuCapture={lockMe} {...rest}>
      <Leds isError={kInfo.keyRenamedErrorInfo?.errorTag.startsWith('prop-prog-key')}/>      
      <Glide showLock={locked} showDelete={false} unlocker={unlockMe}/>
      {mode === LABEL_MODE      && <ProgKeyLabel  keyName={keyName} setEditMode={setEditMode}   isLocked={locked} isJustCreated={justCreated}  key={`progLabelOf-${keyName}`}/> }
      {mode === TEXT_INPUT_MODE && <ProgKeyEdit   folderPath={folderPath} keyName={keyName} setLabelMode={setLabelMode} kInfo={kInfo} tabIx={tabIx} key={`progEditOf-${keyName}`} />}
    </div>
  )
}

    /*
      TODO: Edit Mode and Error Detection Flags
      =========================================
      - Local Flags:
        - Saving... : Save in Progress
        - Server Refreshed / Modified: When another team member (or SDK?) updated this property and it has gone a refresh. maybe color it somehow?

      - TeamWide Shared Flags:
        - Editing + editingBy: usernmae (informative only)
        - Locked for others while editing? - a Customer preference.
        - Special Attention! (by system or by admin or by any member)
        - Locked for any edit (ReadOnly property), by admin or other member.
        - Hidden/Visible according to ACL in that team.
        - IO Health


      Verify:
      - informative team wide editing. 
      
      
      
      DONE:
      - Local User:
        - keyEdit.

      1. Called by Label: setEditMode.
      2. Switch to Edit.  --> Now curComp is ProgKeyEdit!
          2.1 Mark Local keyEdit: true;
          2.2 sendMsg keyEdit: true to all team members. (so everyone knows it is under edit)
              - If not successful - for now, it's ok. (at least the editing user has its own "editing" indication - by the Edit Mode itself...)
              - Not locking, but edit flag will show for all team members. (informative only for now, not locking)
      3. Edit Done - What to do?      (onBlur click outside, onBlur by [Tab], [Enter] pressed -- what to do?                
          3.1. Local kiponosInfo[savingInProgress]: true;
          3.2. sendMsg - renameProgKey

      4. Save Response - progKeyRenamedData effect:  (response from progKeyRename arrived)
          4.1. onSuccess: All Rendered, All reset to Label Mode.
          4.2. onError: 
                - Drills Down from Table Render - ProgKeyCtrl's job is to decide the mode to show.
                - Still EditMode - No Table Rerender! + Local progKey still at Edit Mode. Team level keyEdit still marked if applicable. So we're still editing this progKey.
                - We got: errorTag, basePath, configPath, oldKey: locate our progKey
                - Local kiponosInfo[savingInProgress]: false.
                - Local kiponosInfo[error]: true.
                - Leds onError.
                  o ProgKeyError - Accordion auto-expanded with error details + suggestions.
                  o (OR, Leds ToolTip with Error Details + Suggestions.)
                  o (OR, Notes column with error details)
                - Save while in Error:
                  - Check last known saved key, If fixed with that oldKey, then it's a rollback:
                    - Cancel all error flags, 
                    - Full Table Rerender.
                    - which will auto-switch to LabelMode on all rows.
                  - Fixed different then last known saved key:
                    - Go To 3.1 - Edit Done... saveInProgress: true, etc..


    */
